export const LOAD_DATA = 'DOCUMENTS_LOAD_DATA'
export const SET_DOCUMENTS = 'DOCUMENTS_SET_DOCUMENTS'

export const loadData = () => {
  return { type: LOAD_DATA }
}
export const setDocuments = (data) => {
  return { type: SET_DOCUMENTS, data: data }
}
